export enum CollectionMethod {
	ChargeAutomatically = "charge_automatically",
	SendInvoice = "send_invoice",
}

export enum CusProductStatus {
	Scheduled = "scheduled",
	Active = "active",
	PastDue = "past_due",
	Expired = "expired",
	Unknown = "unknown",
	Trialing = "trialing",
	Paused = "paused",
}
